/**
 * Heatmap app root component.
 */

/** Dependencies -------------------------------------------- */

// External

import { useEffect } from 'react'

// Internal

import { getPlugin } from '../dictionary'

import { useAppState } from '../state'

import Preloader from './preloader'
import Error from './error'
import Preamble from './preamble'
import Heatmap from './heatmap'
import DataPanel from './dataPanel'

import LogoLockupSvg from '../../../img/svg/_brand-logo-lockup.svg'
import LogoSmallLockupSvg from '../../../img/svg/_brand-logo-small-lockup.svg'
import Button from './button'

import { timestampToDateString } from '../../helpers'

/** Main ---------------------------------------------------- */

const baseClassName = 'app'

export default function App() {

    // Constants

    const plugin = getPlugin()

    const initialize = useAppState( ( state ) => state.initialize )

    // Effects

    useEffect( () => { initialize() } )

    return (
        <div className={ baseClassName }>

            <Preloader/>
            <Error/>
            <Preamble/>

            <header className={ `${baseClassName}__header` }>
                <LogoSmallLockupSvg className={ `${baseClassName}__logo-small-lockup` }/>
                <LogoLockupSvg className={ `${baseClassName}__logo-lockup` }/>
                <Button title="Main site" link={ plugin.mainSiteUrl } type="naked" theme="text" trailingIconProps={ { type: 'arrowRight' } }/>
            </header>

            <main className={ `${baseClassName}__main` }>
                <Heatmap/>
                <DataPanel/>
            </main>

            <footer className={ `${baseClassName}__footer` }>
                <p className={ `${baseClassName}__info` }>
                    <span className={ `${baseClassName}__copyright` }>&copy; Protect Democracy</span>
                    <a className={ `${baseClassName}__faqs` } href={ plugin.faqsUrl } target="_blank">Dashboard FAQs</a>
                </p>
                <p className={ `${baseClassName}__updates` }>
                    <time className={ `${baseClassName}__last-update` }>Last update: { timestampToDateString( plugin.lastUpdate, false ) }</time>
                    { plugin.nextUpdate && <time className={ `${baseClassName}__next-update` }>Next update: { timestampToDateString( plugin.nextUpdate, false ) }</time> }
                </p>
                <p className={ `${baseClassName}__attribution` }>
                    <a href="https://mapbox.com/maps" target="_blank">&copy; Mapbox</a>
                    <a className={ `${baseClassName}__attribution-link` } href="https://www.openstreetmap.org/about/" target="_blank">&copy; OpenStreetMap</a>
                </p>
            </footer>

        </div>
    )
}
